import NavBar from '@/components/feature/NavBar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HighlightStrip from './components/HighlightStrip';
import BrowseSection from './components/BrowseSection';
import RankingSection from './components/RankingSection';
import ScheduleSection from './components/ScheduleSection';
import GuideSection from './components/GuideSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <NavBar />
      <main>
        <HeroSection />
        <HighlightStrip />
        <BrowseSection />
        <RankingSection />
        <ScheduleSection />
        <GuideSection />
        <CtaSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}